var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      directives: [{ name: "scroll-to", rawName: "v-scroll-to" }],
      class: ["btn-top", { "btn-top--visible": _vm.isVisible }],
      attrs: { href: "#" }
    },
    [
      _c(
        "svg",
        { attrs: { width: "12", height: "14", viewBox: "0 0 12 14" } },
        [
          _c("path", {
            attrs: {
              d: "M12 5.9L6.1 0 0 6.1l1.4 1.4 3.7-3.7V14h2V3.8l3.5 3.5z"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19e565f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19e565f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/BtnTop.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-19e565f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/BtnTop.vue
// module chunks = 0